import { useReveal } from "../lib/useReveal";

const supporters = [
  {
    name: "Oswal Energies Limited",
    short: "Oswal Energies",
    logo: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/gi3wak7a_image.png",
    tag: "Energy & Infrastructure",
    url: "https://www.oswalenergies.com/",
  },
  {
    name: "Oswal Industries Limited",
    short: "Oswal Industries",
    logo: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/mp5aceoi_image.png",
    tag: "Industrial Manufacturing",
    url: "https://www.oswalvalves.com/",
  },
  {
    name: "Nimba Nature Cure Private Limited",
    short: "Nimba Nature Cure",
    logo: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/o4bz0pq9_image.png",
    tag: "Wellness & Healing",
    url: "https://www.nimba.in/",
  },
  {
    name: "Metal Forge India Private Limited",
    short: "Metal Forge India",
    logo: "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/uw1h9pzu_image.png",
    tag: "Precision Forging",
    url: "https://metalforgeindia.com/",
  },
];

export default function Supporters() {
  const ref = useReveal();
  return (
    <section
      id="supporters"
      data-testid="supporters-section"
      className="py-24 md:py-32 bg-[#FDFBF7] border-t border-[#E3DECE]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">
              With gratitude
            </span>
            <span className="h-[1px] w-10 bg-[#D4AF37]" />
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
            Standing beside us, <span className="italic text-[#1B4D3E]">quietly and steadily</span>.
          </h2>
          <p className="mt-6 text-[#4A5D53] leading-relaxed">
            Our work would not be possible without these organisations whose
            generosity fuels every rescue, every meal and every healing.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {supporters.map((s, i) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`supporter-card-${i}`}
              className="group relative bg-[#FDFBF7] border border-[#E3DECE] rounded-2xl p-8 hover:-translate-y-1 transition-all duration-500 hover:shadow-[0_20px_40px_-20px_rgba(27,77,62,0.25)] overflow-hidden block"
            >
              <div className="absolute -top-6 -right-6 w-24 h-24 rounded-full border border-[#D4AF37]/30 pointer-events-none" />
              <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full border border-[#D4AF37]/15 pointer-events-none" />

              <div className="relative flex items-center justify-center w-20 h-20 rounded-2xl bg-white border border-[#E3DECE] p-3">
                <img
                  src={s.logo}
                  alt={`${s.short} logo`}
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>

              <div className="mt-8">
                <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                  {s.tag}
                </div>
                <h3 className="mt-2 font-display text-xl md:text-[22px] text-[#1A2E24] leading-snug">
                  {s.name}
                </h3>
              </div>

              <div className="mt-6 h-[1px] w-full bg-[#E3DECE]" />
              <div className="mt-4 text-[11px] tracking-[0.18em] uppercase text-[#7A8C81] flex items-center gap-1">
                Principal Supporter
                <span className="text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity">→</span>
              </div>
            </a>
          ))}
        </div>

        <p className="mt-12 text-center text-sm text-[#7A8C81]">
          Interested in supporting Hastkesar Panjrapole?{" "}
          <a
            href="#contact"
            data-testid="supporters-contact-link"
            className="text-[#1B4D3E] underline decoration-[#D4AF37] underline-offset-4 hover:text-[#D4AF37]"
          >
            Reach out to us →
          </a>
        </p>
      </div>
    </section>
  );
}
